import axios from 'axios'
import token from './token'
import router from '../router'
import store from './../store'

let api = axios.create({
  baseURL: '/api'
})

/*
 * The interceptor here ensures that we check for the token in local storage every time an ajax request is made
 */
api.interceptors.request.use(
  (config) => {
    let tokenData = token.get()

    if (tokenData) {
      config.headers['Authorization'] = `Bearer ${tokenData}`
    }

    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use((response) => {
  return response
}, (err) => {
  return new Promise(() => {
    if (err.response.status === 401) {
      store.dispatch('security/logout')
      router.push({ path: '/login' })
    } else if ((err.response.status === 500) && (process.env.NODE_ENV === 'development')) {
      document.open()
      document.write(err.response.data)
      document.write(err.message)
      document.close()
    }
    throw err
  })
})

export default api
